import React from 'react';
import { Box, Input } from '@nimbus-ds/components';

function WithdrawsFilterSkeleton(): JSX.Element {
  return (
    <Box display="flex" flexDirection="column" alignItems="stretch" gap="4">
      <Input.Skeleton />
    </Box>
  );
}

export default WithdrawsFilterSkeleton;
